module.exports = __webpack_public_path__ + "img/help.043253fb.webp";